import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled, { css } from 'styled-components';

import {
	TalentReview,
	UnshareTalentReviewInput,
	useUnShareTalentReviewMutation,
} from '@treams/treams-network';
import { Button, Paragraph } from '@treams/treams-ui';

export const TalentReviewUndo = ({ id }: { id: TalentReview['id'] }) => {
	const { t } = useTranslation('', { keyPrefix: 'talentReviews.unshare' });
	const [unshare] = useUnShareTalentReviewMutation();

	const unshareTalentReview = async () => {
		const input: UnshareTalentReviewInput = {
			id,
		};

		await unshare({ variables: { input } });
	};

	return (
		<TalentReviewUndoCard>
			<Paragraph pl={3} flexGrow={1}>
				{t('description')}
			</Paragraph>
			<Button
				type="primary"
				title={t('button.title')}
				onClick={async () => await unshareTalentReview()}
				small
			/>
		</TalentReviewUndoCard>
	);
};

const TalentReviewUndoCard = styled(Box)`
	${({ theme }) => css`
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		padding: 8px;
		border-radius: 10px;
		background-color: ${theme.colors.lightBlueLight};
	`}
`;
